export const GLOBAL_DBN_AGENTS_RESET_STATE = 'GLOBAL_DBN_AGENTS_RESET_STATE';
export const GLOBAL_DBN_AGENTS_CURRENT_ITEM = 'GLOBAL_DBN_AGENTS_CURRENT_ITEM';

export const GLOBAL_DBN_AGENTS_REQUEST_LOADING = 'GLOBAL_DBN_AGENTS_REQUEST_LOADING';
export const GLOBAL_DBN_AGENTS_REQUEST_SUCCESS = 'GLOBAL_DBN_AGENTS_REQUEST_SUCCESS';
export const GLOBAL_DBN_AGENTS_REQUEST_FAILED = 'GLOBAL_DBN_AGENTS_REQUEST_FAILED';

export const GLOBAL_DBN_AGENTS_CURRENT_ACTION = 'GLOBAL_DBN_AGENTS_CURRENT_ACTION';
export const GLOBAL_DBN_AGENTS_RESET_ACTION = 'GLOBAL_DBN_AGENTS_RESET_ACTION';